import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

const CountdownTimer = ({ targetTime }) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const theme = useTheme();

  const convertTimeStringToTimestamp = timeString => {
    const [hours, minutes] = timeString.split(':').map(Number);
    const now = new Date();
    const targetDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      hours,
      minutes,
      0,
      0
    );
    return targetDate.getTime();
  };

  useEffect(() => {
    if (targetTime === null) return;

    const targetTimestamp = convertTimeStringToTimestamp(targetTime);

    const calculateTimeLeft = () => targetTimestamp - new Date().getTime();

    setTimeLeft(calculateTimeLeft());

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  const formatTimeLeft = milliseconds => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const countdownTimerStyle = {
    borderRadius: '8px',
    border:
      theme.palette.type === 'dark' ? '1px solid #5A8B4A' : '1px solid #83C06F',
    padding: '8px',
    backgroundColor: theme.palette.type === 'dark' ? '#2E3B2F' : '#E1EFE3',
    color: theme.palette.type === 'dark' ? '#5A8B4A' : '#83C06F',
    textAlign: 'center',
    display: 'inline-block',
    marginLeft: '10px',
  };

  if (targetTime === null) return null;

  return (
    <div style={countdownTimerStyle}>
      <Typography>
        {timeLeft > 0 ? formatTimeLeft(timeLeft) : 'Robot Leaving'}
      </Typography>
    </div>
  );
};

CountdownTimer.propTypes = {
  targetTime: PropTypes.string,
};

export default CountdownTimer;
